// import React, { useState } from "react";
// import { DialogBox } from "../../../../../components/Elements/DialogBox";
// import { ReactComponent as DownloadIcon } from "../../../../../assets/svgs/download-icon.svg";
// import { Button } from "antd";
// import { ReactComponent as EyeIcon } from "../../../../../assets/svgs/eye-icon.svg";
// import { useEffect } from "react";
// import { getApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";

// const statuses = [
//   { label: "BRSR REPORT", value: "BRSR REPORT" },
//   { label: "CARBON FOOTPRINT REPORT", value: "CARBON FOOTPRINT REPORT" },
//   { label: "AUDIT REPORT", value: "AUDIT REPORT" },
// ];

// const ViewReport = ({ onOpen, onClose ,item, reportData,  reportId}) => {
//   console.log(  reportId," reportIditemssssssssssssssssss");
// const [ReportAll,setReportAll]=useState();

// const fetchReportsAll= async ()=>{
// try {
//   const response=await getApi({
//     apiUrl:API_URLS.VIEW_ALL_REPORTS(reportId)
//   })
// const data=response.data.reports.map((item,index)=>({
//   key:item._id,
//   reportname:item.fileName,
//   reportview:item.filePath

// }))
//   setReportAll(data)
//   console.log(response,"fetchReportsAll");
// } catch (error) {

// }
// }

// useEffect(()=>{
// fetchReportsAll();
// },[])
//   return (
//     <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
//       {/* Header */}
//       <h3 className="text-lg text-[#06513D] px-4 mb-6 font-medium">
//         Report View
//       </h3>

//       {/* Status List */}
//       <div className="space-y-6 px-6">
//         {ReportAll?.map((status) => (
//           <div
//             key={status.key}
//             className="flex justify-between items-center border border-gray-300 rounded-full px-5 py-2"
//           >
//             {/* Status Label */}
//             <span className="text-sm font-medium text-gray-700">
//               {status.reportname}
//             </span>

//             {/* Action Icons */}
//             <div className="flex items-center gap-4">
//               <EyeIcon
//                 className="cursor-pointer"
//                 style={{ fontSize: "18px" }}
//               />
//               <DownloadIcon
//                 className="cursor-pointer"
//                 style={{ fontSize: "18px" }}
//               />
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Footer */}
//       <div className="flex justify-center mt-8 px-4">
//         <Button
//           onClick={onClose}
//           className="border border-[#06513D] text-[#06513D] hover:bg-[#f0fdfa]"
//         >
//           Cancel
//         </Button>
//       </div>
//     </DialogBox>
//   );
// };

// export default ViewReport;

import React, { useState, useEffect, useCallback } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { ReactComponent as DownloadIcon } from "../../../../../assets/svgs/download-icon.svg";
import { Button } from "antd";
import { ReactComponent as EyeIcon } from "../../../../../assets/svgs/eye-icon.svg";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";

const ViewReport = ({ onOpen, onClose, reportData, reportId }) => {
  console.log(reportId, "reportId");
  const [ReportAll, setReportAll] = useState([]);
  const [loading, setLoading] = useState(false);

  // Handle preview - opens file in new tab
  const handlePreview = (filePath) => {
    if (filePath) {
      window.open(filePath, "_blank", "noopener,noreferrer");
    } else {
      alert("Preview not available for this report.");
    }
  };

  // Handle download - downloads the file
  const handleDownload = (filePath, fileName) => {
    if (filePath) {
      // Create a temporary link element
      const link = document.createElement("a");
      link.href = filePath;
      link.download = fileName || "report.pdf"; // Set filename
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      alert("Download not available for this report.");
    }
  };

  const fetchReportsAll = useCallback(async () => {
    if (!reportId) return;

    setLoading(true);
    try {
      const response = await getApi({
        apiUrl: API_URLS.VIEW_ALL_REPORTS(reportId),
      });

      const data = response.data.reports.map((item, index) => ({
        key: item._id,
        reportname: item.fileName,
        reportview: item.viewUrl,
      }));

      setReportAll(data);
      console.log(response, "fetchReportsAll");
    } catch (error) {
      console.error("Error fetching reports:", error);
      alert("Failed to load reports. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [reportId]);

  useEffect(() => {
    fetchReportsAll();
  }, [fetchReportsAll]);

  return (
    <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
      {/* Header */}
      <h3 className="text-lg text-[#06513D] px-4 mb-6 font-medium">
        Report View
      </h3>

      {/* Loading State */}
      {/* {loading && (
        <div className="text-center py-8 text-gray-500">
          Loading reports...
        </div>
      )} */}

      {/* Empty State */}
      {/* {!loading && ReportAll?.length === 0 && (
        <div className="text-center py-8 text-gray-500">
          No reports available
        </div>
      )} */}

      {/* Status List */}
      <div className="space-y-6 px-6">
        {ReportAll?.map((report) => (
          <div
            key={report.key}
            className="flex justify-between items-center border border-gray-300 rounded-full px-5 py-2"
          >
            {/* Status Label */}
            <span className="text-sm font-medium text-gray-700">
              {report.reportname}
            </span>

            {/* Action Icons */}
            <div className="flex items-center gap-4">
              <EyeIcon
                className="cursor-pointer hover:opacity-70 transition-opacity"
                style={{ fontSize: "18px" }}
                onClick={() => handlePreview(report.reportview)}
                title="Preview Report"
              />
              <DownloadIcon
                className="cursor-pointer hover:opacity-70 transition-opacity"
                style={{ fontSize: "18px" }}
                onClick={() =>
                  handleDownload(report.reportview, report.reportname)
                }
                title="Download Report"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="flex justify-center mt-8 px-4">
        <Button
          onClick={onClose}
          className="border border-[#06513D] text-[#06513D] hover:bg-[#E6EDEB] hover:border-[#06513D] "
        >
          Cancel
        </Button>
      </div>
    </DialogBox>
  );
};

export default ViewReport;
